import { Pipe, PipeTransform } from '@angular/core';
import { CplItemSubType } from 'src/app/model/enum/cpl-item-sub-type.enum';
import { BaseItemHelpersService } from 'src/app/services/base-item-helpers/base-item-helpers.service';

@Pipe({
    name: 'itemSubtype'
})
export class ItemSubtypePipe implements PipeTransform {
    constructor(private baseItemHelpersService: BaseItemHelpersService) {}

    transform(value: CplItemSubType | undefined | null): string {
        return this.baseItemHelpersService.getItemSubTypeLabel(value);
    }

}
